__turbopack_context__.v({
  "description": "auth-card-module-scss-module__Qw20mW__description",
  "header": "auth-card-module-scss-module__Qw20mW__header",
  "logo": "auth-card-module-scss-module__Qw20mW__logo",
  "logo_img": "auth-card-module-scss-module__Qw20mW__logo_img",
  "root": "auth-card-module-scss-module__Qw20mW__root",
});
